import { render, staticRenderFns } from "./tp-catering.vue?vue&type=template&id=82249046&scoped=true"
import script from "./tp-catering.vue?vue&type=script&lang=js"
export * from "./tp-catering.vue?vue&type=script&lang=js"
import style0 from "./tp-catering.vue?vue&type=style&index=0&id=82249046&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82249046",
  null
  
)

export default component.exports